import { Fragment, memo, useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import { FullTextPositionToolTip, useMousePosition } from 'ui_kit_qmd'
import './PatientInfoCardRows.scss'
import { isActiveEllipsisCheck } from '../../../../utils/common'
import { STATUS_TEXT } from '../../../../utils/constants'
import { getVisitMethodIconProps } from '../../../new-visit/components/visit-information/getVisitMethodIconProps'
import { getVisitTypeLabel } from '../../../../utils/getVisitTypeLabel'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getVisitValueId = (visitTypeValue, keyValue) => {
  if (visitTypeValue) {
    return 'patient-info-card-row-visit-type-name'
  }

  if (keyValue === `${STATUS_TEXT}:`) {
    return 'patient-info-card-row-visit-status-name'
  }
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const PatientInfoCardRows = memo(({ infoConfig }) => {
  const mousePosition = useMousePosition()

  const [isVisitTypeEllipsed, setIsVisitTypeEllipsed] = useState(false)
  const [isMouseOverVisitType, setIsMouseOverVisitType] = useState(false)
  const [visitTypeTooltipTitle, setVisitTypeTooltipTitle] = useState('')
  const [isStatusEllipsed, setIsStatusEllipsed] = useState(false)
  const [isMouseOverStatus, setIsMouseOverStatus] = useState(false)
  const [statusTooltipTitle, setStatusTooltipTitle] = useState('')

  useEffect(() => {
    isActiveEllipsisCheck(`patient-info-card-row-visit-type-name`, setIsVisitTypeEllipsed)
  }, [isMouseOverVisitType])

  useEffect(() => {
    isActiveEllipsisCheck('patient-info-card-row-visit-status-name', setIsStatusEllipsed)
  }, [isMouseOverStatus])

  const visitTypeTooltipContainerPositionStyle = useMemo(
    () => ({
      left: mousePosition.Ox - 250,
      top: Number(mousePosition.Oy) + 20,
    }),
    [mousePosition],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverVisitType = (titleValue) => () => {
    if (!visitTypeTooltipTitle) {
      setVisitTypeTooltipTitle(titleValue)
    }
    setIsMouseOverVisitType(true)
  }

  const onMouseOutVisitType = () => setIsMouseOverVisitType(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverStatus = (titleValue) => () => {
    if (!statusTooltipTitle) {
      setStatusTooltipTitle(titleValue)
    }
    setIsMouseOverStatus(true)
  }

  const onMouseOutStatus = () => setIsMouseOverStatus(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getValueMouseOverAction = (visitTypeValue, keyValue, tooltipValue) => {
    if (visitTypeValue) {
      return onMouseOverVisitType(tooltipValue)
    }

    if (keyValue === `${STATUS_TEXT}:`) {
      return onMouseOverStatus(tooltipValue)
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getValueMouseOutAction = (visitTypeValue, keyValue) => {
    if (visitTypeValue) {
      return onMouseOutVisitType
    }

    if (keyValue === `${STATUS_TEXT}:`) {
      return onMouseOutStatus
    }
  }

  return (
    <>
      {isVisitTypeEllipsed && isMouseOverVisitType ?
        <FullTextPositionToolTip
          title={visitTypeTooltipTitle}
          toolTipContainerPositionStyle={visitTypeTooltipContainerPositionStyle}
        />
      : null}
      {isStatusEllipsed && isMouseOverStatus ?
        <FullTextPositionToolTip
          title={statusTooltipTitle}
          toolTipContainerPositionStyle={visitTypeTooltipContainerPositionStyle}
        />
      : null}
      {/*
       // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
      {infoConfig.map((configItem, index) => {
        if (Array.isArray(configItem)) {
          return (
            // eslint-disable-next-line react/no-array-index-key -- fixed positional config group with no stable id
            <div key={index} className='patient-info-card-row-wrapper'>
              {/*
               // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered */}
              {configItem.map(({ key, visitType, className, value }) => {
                const displayValue = visitType ? getVisitTypeLabel(value, visitType) : value

                return (
                  <Fragment key={`${key ?? ''}-${visitType ?? ''}`}>
                    {visitType ?
                      // eslint-disable-next-line jsx-a11y/alt-text -- alt is provided by getVisitMethodIconProps
                      <img className='patient-info-card-row-method-icon' {...getVisitMethodIconProps(visitType)} />
                    : null}
                    {key ?
                      <div className='patient-info-card-row-text patient-info-card-row-key'>{key}</div>
                    : null}
                    {value ?
                      <>
                        <div
                          id={getVisitValueId(visitType, key)}
                          className={classNames('patient-info-card-row-text patient-info-card-row-value', {
                            'patient-info-card-row-visit-type-name': !!visitType || key === `${STATUS_TEXT}:`,
                            [className]: className,
                          })}
                          onMouseOver={getValueMouseOverAction(visitType, key, displayValue)}
                          onMouseOut={getValueMouseOutAction(visitType, key)}
                          onFocus={() => {}}
                          onBlur={() => {}}>
                          {displayValue}
                        </div>
                        <div className='patient-info-card-row-separator' />
                      </>
                    : null}
                  </Fragment>
                )
              })}
            </div>
          )
        }

        return (
          <div key={configItem.key} className='patient-info-card-row-wrapper'>
            <div className='patient-info-card-row-text patient-info-card-row-key'>{configItem.key}</div>
            <div
              id={configItem?.id ?? null}
              className={classNames('patient-info-card-row-text patient-info-card-row-value', {
                [configItem?.className]: configItem?.className,
              })}>
              {configItem.value}
            </div>
          </div>
        )
      })}
    </>
  )
})
